import { domIdentitiesIterator } from "../dsCoverage/utils/iterators.js";
import { identityToString } from "./utils.js";
function aggregateCoverage(collection) {
  const stats = /* @__PURE__ */ new Map();
  let totalPixels = 0;
  for (const element of domIdentitiesIterator(collection)) {
    const { identity } = element;
    const currentStats = stats.get(identity) ?? { count: 0, pixels: 0 };
    const width = element.right - element.left;
    const height = element.bottom - element.top;
    const area = width * height;
    totalPixels += area;
    currentStats.count++;
    currentStats.pixels += area;
    stats.set(identity, currentStats);
  }
  const flatStats = [];
  for (const element of stats.entries()) {
    const [identity, stats2] = element;
    const identityName = identityToString(identity);
    flatStats.push({
      ...stats2,
      identity,
      identityName,
      totalPixels
    });
  }
  return flatStats;
}
export {
  aggregateCoverage
};
//# sourceMappingURL=aggregateCoverage.js.map
